module.exports = "/_next/static/images/teaches-default-img-b07a49f45a4ae58454454610a634f92d.jpg";